<div class="container">
  @if (withLabel) {
    <ion-label [ngClass]="baseCssClass">Type:</ion-label>
  }

  @if (disabled) {
    <rc-service-type-badge [serviceType]="fieldValue"></rc-service-type-badge>
  }

  @if (!disabled) {
    <ion-select
      [ngClass]="baseCssClass"
      [value]="fieldValue"
      placeholder="Select a value"
      (ionChange)="onInputChange($event)">
      @for (entry of serviceTypeEntries; track entry.value) {
        <ion-select-option [value]="entry.value">
          {{ entry.label }}
        </ion-select-option>
      }
    </ion-select>
  }
</div>
